import { getTranslation } from '@easy-expense/intl-client';
import { Icon } from '@easy-expense/ui-shared-components';
import { theme } from '@easy-expense/ui-theme';
import { Layout, Spacer } from '@easy-expense/ui-web-core';
import React from 'react';

import { LabelTextField } from '../../LabelTextField.component';

export const TransactionNumberField: React.FC<
  React.PropsWithChildren<{
    transactionID: string | undefined | null;
    onChange: (transactionID: string) => void;
  }>
> = ({ transactionID, onChange }) => {
  const [isFocused, setIsFocused] = React.useState<boolean>(false);

  return (
    <LabelTextField label={getTranslation('Trans. #')} active={isFocused}>
      <Layout.Row align style={{ width: '100%' }}>
        <Icon name="receipt-outline" size={20} />
        <Spacer.Horizontal size={8} />
        <input
          name="transactionID"
          value={transactionID ?? ''}
          placeholder="XXXXXX"
          onChange={(event) => onChange(event.currentTarget.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          style={{
            flexGrow: 1,
            width: '100%',
            border: 'none',
            outline: 'none',
            backgroundColor: theme.colors.inputBackground,
          }}
        />
      </Layout.Row>
    </LabelTextField>
  );
};
